import { useState, useEffect } from 'react';
import { Menu, X, ChevronDown } from 'lucide-react';

const navLinks = [
  { label: 'Inicio', href: '#inicio' },
  { label: 'Qué es Prestagro', href: '#solucion' },
  { label: 'Características', href: '#caracteristicas' },
  { label: 'AgroScan', href: '#agroscan' },
  { label: 'Beneficios', href: '#beneficios' },
  { label: 'Blog', href: '#blog' },
  { label: 'Nosotros', href: '#nosotros' },
];

export const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <nav
      aria-label="Menú principal"
      data-testid="main-navbar"
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-[#FBF5EA]/95 backdrop-blur-xl shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a
            href="#inicio"
            onClick={(e) => scrollToSection(e, '#inicio')}
            className="flex items-center gap-2"
            data-testid="logo-link"
          >
            <img 
              src="https://customer-assets.emergentagent.com/job_prestagro-agro/artifacts/nb3u8jqh_logo-prestagro.png" 
              alt="Prestagro Logo" 
              className={`h-10 w-auto transition-all duration-300 ${
                isScrolled ? 'invert' : ''
              }`}
            />
          </a>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => scrollToSection(e, link.href)}
                className={`text-sm font-medium transition-colors duration-300 ${
                  isScrolled 
                    ? 'text-[#051914] hover:text-[#A9CB68]' 
                    : 'text-white hover:text-[#A9CB68]'
                }`}
                data-testid={`nav-link-${link.href.replace('#', '')}`}
              >
                {link.label}
              </a>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden lg:flex items-center gap-4">
            <a
              href="#contacto"
              onClick={(e) => scrollToSection(e, '#contacto')}
              className="bg-[#A9CB68] text-[#051914] font-medium px-6 py-3 rounded-full hover:bg-[#98BA57] transition-all hover:-translate-y-0.5"
              data-testid="nav-cta-button"
            >
              Contáctanos
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden p-2 transition-colors duration-300 ${
              isScrolled ? 'text-[#051914]' : 'text-white'
            }`}
            aria-label="Toggle menu"
            data-testid="mobile-menu-toggle"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div
          className="lg:hidden bg-[#FBF5EA] border-t border-[#051914]/10"
          data-testid="mobile-menu"
        >
          <div className="px-6 py-4 space-y-4">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => scrollToSection(e, link.href)}
                className="block text-base font-medium text-[#051914] hover:text-[#A9CB68] transition-colors py-2"
                data-testid={`mobile-nav-link-${link.href.replace('#', '')}`}
              >
                {link.label}
              </a>
            ))}
            <a
              href="#contacto"
              onClick={(e) => scrollToSection(e, '#contacto')}
              className="block w-full text-center bg-[#A9CB68] text-[#051914] font-medium px-6 py-3 rounded-full hover:bg-[#98BA57] transition-all mt-4"
              data-testid="mobile-cta-button"
            >
              Contáctanos
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};
